module.exports = __webpack_public_path__ + "static/media/2-min.723c5462.png";